module.exports = __webpack_public_path__ + "img/24.c91f5a3.jpg";